import type { Quiz409Translations } from './quizExpired.translation.pl.ts';

export const quizExpiredTranslations: Quiz409Translations = {
  title: 'Oups ! Le temps est écoulé.',
  subMessage: "Cette année, tu n'as pas réussi à terminer toutes les tâches de qualification.",
  buttons: {
    back: 'Retour',
  },
};
